import { Layers, Gauge, AlertTriangle, Send } from 'lucide-react'

export const TM_CHECKLIST_ICONS: Record<string, typeof Layers> = {
  structuring: Layers,
  velocity: Gauge,
  threshold: AlertTriangle,
  'alert-routing': Send,
}

export const TM_CHECKLIST_DESCRIPTIONS: Record<string, string> = {
  structuring: 'Catches several transfers deliberately kept just under the reporting limit.',
  velocity: 'Catches unusually fast or frequent activity in a short window.',
  threshold: 'Flags any single transaction over the reporting limit.',
  'alert-routing': 'Sends anything flagged straight to the right review queue.',
}
